const Loaders = () => {
    return (
        <h1>Loading please wait</h1>
    )
}

export default Loaders